import * as React from 'react';

const DARK_QUERY = '(prefers-color-scheme: dark)';

const darkQuery = (): MediaQueryList | undefined => {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(DARK_QUERY)
    : undefined;
}

/**
 * Whether the phone or browser is set to dark, kept current while it changes, as scheduled dark mode
 * does at sunset. False where the preference cannot be read.
 *
 * The iOS app only sees the phone's setting when its Info.plist does not force a light interface
 * (UIUserInterfaceStyle in config.xml).
 */
export const useSystemDarkMode = (): boolean => {
  const [dark, setDark] = React.useState<boolean>(() => {
    const query = darkQuery();
    return !!query && query.matches;
  });

  React.useEffect(() => {
    const query = darkQuery();
    if (!query) {
      return undefined;
    }
    const update = () => setDark(query.matches);
    update();
    // Safari before 14 only has the older listener API.
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', update);
      return () => query.removeEventListener('change', update);
    }
    query.addListener(update);
    return () => query.removeListener(update);
  }, []);

  return dark;
}



// WEBPACK FOOTER //
// ./src/helpers/colorScheme.ts